import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Flex,
  Grid,
  Input,
  Select,
  Title,
  Tooltip,
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { modals } from "@mantine/modals";
import {
  IconRefresh,
  IconSearch,
  IconStack,
  IconTimeDuration15,
  IconUserCode,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_PaginationState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import * as xlsx from "xlsx";
import BreadCrumb from "../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import {
  isNullOrUndefined,
  isNullOrUndefinedArry,
} from "../../../_base/extension/StringExtension";
import Repository from "../../../_base/helper/HttpHelper";
import { ParamSearchBase } from "../../../_base/model/_base/ParamSearchBase";
import { getDataProvice } from "../../../api/ApiAddress";
import { getDataEmployeekdol } from "../../../api/ApiEmployee";
import { getDataSaleOrderStatus } from "../../../api/ApiOrderStatus";
import AppAction from "../../../common/AppAction";
import {
  formatDateNotTimeZone,
  formatDateTransfer,
} from "../../../common/FormatDate/FormatDate";
import { _localization } from "../../../config/location";
import { API_ROUTE } from "../../../const/apiRoute";
import { apiPOS } from "../../../library/axios";
import { tblEmployeekdol } from "../../../model/TblEmployee";
import { tblSaleOrderCommand } from "../../../model/TblSaleOrder";
import AssignView from "./AssignView";
import DeleteView from "./DeleteView";
import EditView from "./EditView";
import OrderView from "./OrderView";
import PosView from "./PosView";
import UserView from "./UserView";

const OrderList = () => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);
  const location = useLocation();
  const buyerId = location.state && location.state.buyerId;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | undefined>();
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [paramSearch, setParamSearch] = useState<ParamSearchBase>();
  const [isSelectedItem, setSelectedItems] = useState<any[]>([]);
  const [datas, setDatas] = useState<tblSaleOrderCommand[]>([]);
  const [rowCount, setRowCount] = useState(0);
  // Trạng thái đơn hàng
  const [dataOrderStatus, setDataOrderStatus] = useState<any[]>([]);
  const [selectedAssign, setSelectedAssign] = useState("");
  const [inputEmail, setInputEmail] = useState("");
  const [dataProvice, setDataProvice] = useState<any[]>([]);
  const [dataOptionEmployee, setDataOptionEmployee] = useState<any>([]);
  const [dataEmLoy, setDataIEmLoy] = useState<any>([]);
  const [dataEmployee, setDataEmployee] = useState<tblEmployeekdol[]>([]);
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const sizeGrid = { base: 6, sm: 3, md: 3, lg: 3, xl: 1.7 };
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";
  const [selectedStatus, setSelectedStatus] = useState<string>(
    _searchJson && checkedPinSearch ? _searchJson?.selectedStatus : "",
  );

  const orderStatusMap = new Map([
    ["TAO_MOI", "Tạo mới"],
    ["NEW", "Mới"],
    ["new", "Mới"],
    ["CHO_XAC_NHAN", "Chờ xác nhận"],
    ["wait", "Chờ xử lý"],
    ["DA_TIEP_NHAN", "Đã tiếp nhận"],
    ["DA_PHAN_CONG", "Đã phân công"],
    ["CHO_LAY_HANG", "Chờ lấy hàng"],
    ["DANG_GIAO", "Đang giao"],
    ["HOAN_THANH", "Hoàn thành"],
    ["success", "Hoàn thành"],
    ["DA_HUY", "Đã huỷ"],
    ["HUY", "Hủy"],
    ["cancel", "Đã hủy"],
  ]);

  const paymentMethodMap = new Map([
    ["1", "Thanh toán khi nhận hàng (COD)"],
    ["2", "Chuyển khoản ngân hàng"],
    ["3", "Thanh toán bằng thẻ Visa/MasterCard"],
    ["4", "Trả góp qua thẻ"],
    ["5", "Trả góp qua đơn vị tài chính"],
  ]);

  const att2Map = new Map([
    ["1", "Giao hàng tận nơi"],
    ["2", "Nhận tại cửa hàng"],
    ["3", "Giao hoả tốc"],
  ]);

  const att9Map = new Map([["THANH_CONG", "Đã đồng bộ"]]);

  const columns = React.useMemo<MRT_ColumnDef<tblSaleOrderCommand>[]>(
    () => [
      {
        header: "STT",
        accessorKey: "STT",
        Cell: ({ row }) => <>{row?.index + 1}</>,
        size: 100,
      },
      {
        accessorKey: "orderNumber",
        header: "Mã đơn hàng",
        size: 160,
        Cell: ({ renderedCellValue, row }) => (
          <>
            <Badge
              variant="dot"
              radius="xs"
              style={{
                cursor: "pointer",
              }}
              size="lg"
              // color={renderedCellValue === null ? "red" : green.base}
            >
              {renderedCellValue}
            </Badge>
          </>
        ),
      },

      {
        accessorKey: "buyerName",
        header: "Khách hàng",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
        // truncateText: true,
        // render: (buyerName: string) => <Text>{buyerName}</Text>,
      },
      {
        accessorKey: "buyerTelephone",
        header: "SĐT khách hàng",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
        // sortable: true,
        // truncateText: true,
        // render: (buyerTelephone: string) => <Text>{buyerTelephone}</Text>,
      },
      {
        accessorKey: "payMethodId",
        header: "Phương thức thanh toán",
        size: 220,
        Cell: ({ renderedCellValue }) => {
          return (
            <>
              {paymentMethodMap.get(String(renderedCellValue)) ||
                renderedCellValue}
            </>
          );
        },
      },
      {
        accessorKey: "orderStatus",
        header: "Trạng thái đơn hàng",
        Cell: ({ renderedCellValue }) => {
          return (
            <>
              {orderStatusMap.get(renderedCellValue as string) ||
                renderedCellValue}
            </>
          );
        },
      },
      {
        accessorKey: "attribute2",
        header: "Hình thức giao hàng",
        Cell: ({ renderedCellValue }) => {
          return (
            <>{att2Map.get(String(renderedCellValue)) || renderedCellValue}</>
          );
        },
      },
      {
        accessorKey: "orderDate",
        header: "Thời gian khách hàng đặt đơn",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "attribute20",
        header: "Thời gian tiếp nhận",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && renderedCellValue}</>
        ),
      },
      {
        accessorKey: "attribute21",
        header: "Tên nhân viên tiếp nhận",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && renderedCellValue}</>
        ),
      },
      {
        accessorKey: "attribute9",
        header: "Trạng thái đồng bộ xuống POS",
        Cell: ({ renderedCellValue }) => {
          return (
            <>{att9Map.get(renderedCellValue as string) || renderedCellValue}</>
          );
        },
      },
      {
        accessorKey: "totalAmountFinal",
        header: "Tổng tiền sau khuyến mãi",
        Cell: ({ renderedCellValue }: any) => (
          <>{formatCurrencyVND(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "totalAmount",
        header: "Tổng tiền đơn hàng",
        Cell: ({ renderedCellValue }: any) => (
          <>{formatCurrencyVND(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "amountPaid",
        header: "Tổng tiền đã thanh toán",
        Cell: ({ renderedCellValue }: any) => (
          <>{formatCurrencyVND(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "totalRemainingAmount",
        header: "Tổng tiền còn lại",
        Cell: ({ renderedCellValue }: any) => (
          <>{formatCurrencyVND(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
        enableResizing: false,
        size: 100,
        Cell: ({ row }) => (
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <Tooltip label="Đồng bộ dữ liệu với POS">
              <ActionIcon
                variant="light"
                aria-label="Đồng bộ"
                color="blue"
                onClick={async () => {
                  const { id: orderId, orderNumber } = row.original;
                  if (orderId && orderNumber) {
                    await updateOrderData(orderId, orderNumber);
                  } else {
                    NotificationExtension.Warn(
                      "Dữ liệu không hợp lệ để đồng bộ!",
                    );
                  }
                }}
              >
                <IconRefresh size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
          </Box>
        ),
      },
    ],
    [],
  );

  const formSeachInput = useForm({
    mode: "uncontrolled",
    initialValues: {
      KeySearch: _searchJson && checkedPinSearch ? _searchJson?.KeySearch : "",
      StartDate: _searchJson && checkedPinSearch ? _searchJson?.StartDate : "",
      EndDate: _searchJson && checkedPinSearch ? _searchJson?.EndDate : "",
      empId: _searchJson && checkedPinSearch ? _searchJson?.empId : "",
    },
  });

  const formatDate = (datetime: any) => {
    const date = new Date(datetime);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");

    return `${day}-${month}-${year}, ${hours}:${minutes}`;
  };

  const handleEditData = async (id: number) => {
    if (id) {
      editItem(id);
    } else {
      NotificationExtension.Warn("Xin vui lòng chọn dữ liệu !");
    }
  };

  const getNameById = (id: any) => {
    const province = dataProvice.find((item) => item.provinceId === id);
    return province ? province.provinceName : null;
  };
  const onChange = (selectedOptions: any) => {
    if (!isNullOrUndefinedArry(selectedOptions)) {
      const value = selectedOptions[0].value;
      if (!isNullOrUndefined(value))
        setParamSearch({ ...paramSearch, inActive: value });
    } else setParamSearch({ ...paramSearch, inActive: undefined });
  };

  const onChangeText = (event: React.ChangeEvent<HTMLInputElement>) => {
    const key = event.target.value;
    if (!isNullOrUndefined(key))
      setParamSearch({ ...paramSearch, keyWord: key });
  };

  const onSelectionChange = (selectedItems: any[]) => {
    setSelectedItems(selectedItems);
  };

  const onChangeStatus = (value: any) => {
    setSelectedStatus(value);
  };

  const handleChangeAssign = (selectedValue: any) => {
    setSelectedAssign(selectedValue);
  };

  const handleChangeEmail = (selectedValue: any) => {
    setInputEmail(selectedValue.target.value);
  };

  const fetchDataProvice = async () => {
    try {
      const data = await getDataProvice("Take=64");
      if (data?.data) {
        setDataProvice(data?.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const fetchDataEmloy = async () => {
    const response = await apiPOS.post(
      "/api-pos/api/v1/TblDmEmployee/get-list-web",
      {
        skip: 0,
        take: 100,
        departmentCode: "KDOL",
      },
    );
    if (response && response.data.success) {
      const transformedData = response.data.data
        ?.filter((i: any) => i.id && i.fullname)
        .map((branch: any) => ({
          value: String(branch.id),
          label: branch.fullname,
        }));
      setDataIEmLoy(transformedData);
    }
  };
  // Trạng thái đơn hàng
  const loadDataOrderStatus = async () => {
    setDataOrderStatus([]);
    const data = await getDataSaleOrderStatus("Active=true&Skip=0&Take=1000");
    const transformedData = data?.data.lists.map(
      (item: any, index: number) => ({
        value: item.status,
        label: item.status,
      }),
    );
    setDataOrderStatus(transformedData);
  };

  const loadDataEmployee = async () => {
    setDataEmployee([]);
    const data = await getDataEmployeekdol("Skip=0&Take=1000");
    setDataEmployee(data?.data);
  };

  const formatCurrencyVND = (value: any) => {
    if (value == null) {
      return "";
    }
    // Định dạng số theo chuẩn Việt Nam
    return value.toLocaleString("vi-VN", {
      minimumFractionDigits: 0, // Không hiển thị phần thập phân
      maximumFractionDigits: 0, // Đảm bảo không có chữ số sau dấu phẩy
    });
  };
  const handleExport = () => {
    try {
      // Transform data to match columns configuration
      const exportData = datas.map((item, index) => {
        const formattedData: any = {
          STT: index + 1,
          "Mã đơn hàng": item.orderNumber,
          "Khách hàng": item.buyerName,
          "SĐT khách hàng": item.buyerTelephone,
          "Phương thức thanh toán":
            paymentMethodMap.get(String(item.payMethodId)) || item.payMethodId,
          "Trạng thái đơn hàng":
            orderStatusMap.get(item.orderStatus as string) || item.orderStatus,
          "Hình thức giao hàng":
            att2Map.get(String(item.attribute2)) || item.attribute2,
          "Thời gian khách hàng đặt đơn": item.orderDate
            ? formatDateTransfer(item.orderDate)
            : "",
          "Thời gian tiếp nhận": (item as any).attribute20 || "",
          "Tên nhân viên tiếp nhận": (item as any).attribute21 || "",
          "Trạng thái đồng bộ xuống POS":
            att9Map.get(item.attribute9 as string) || item.attribute9,
          "Tổng tiền sau khuyến mãi": formatCurrencyVND(item.totalAmountFinal),
          "Tổng tiền đơn hàng": formatCurrencyVND(item.totalAmount),
          "Tổng tiền đã thanh toán": formatCurrencyVND(item.amountPaid),
          "Tổng tiền còn lại": formatCurrencyVND(item.totalRemainingAmount),
        };
        return formattedData;
      });
      const worksheet = xlsx.utils.json_to_sheet(exportData);
      const columnWidths = [
        { wch: 5 }, // STT
        { wch: 15 }, // Mã đơn hàng
        { wch: 25 }, // Khách hàng
        { wch: 15 }, // SĐT khách hàng
        { wch: 30 }, // Phương thức thanh toán
        { wch: 20 }, // Trạng thái đơn hàng
        { wch: 20 }, // Hình thức giao hàng
        { wch: 25 }, // Thời gian không đặt đơn
        { wch: 25 }, // Thời gian tiếp nhận
        { wch: 25 }, // Tên nhân viên tiếp nhận
        { wch: 25 }, // Trạng thái đồng bộ xuống POS
        { wch: 25 }, // Tổng tiền sau khuyến mãi
        { wch: 25 }, // Tổng tiền đơn hàng
        { wch: 25 }, // Tổng tiền đã thanh toán
        { wch: 25 }, // Tổng tiền còn lại
      ];
      worksheet["!cols"] = columnWidths;
      const range = xlsx.utils.decode_range(worksheet["!ref"] || "A1");
      const headerStyle = {
        font: { bold: true, color: { rgb: "000000" } },
        fill: { fgColor: { rgb: "EEEEEE" } },
        alignment: { horizontal: "center", vertical: "center" },
        border: {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        },
      };
      const workbook = xlsx.utils.book_new();
      xlsx.utils.book_append_sheet(workbook, worksheet, "Danh sách đơn hàng");
      xlsx.writeFile(workbook, "danh-sach-don-hang.xlsx");
      NotificationExtension.Success("Export excel thành công");
    } catch (error) {
      NotificationExtension.Fails("Export excel thất bại");
    }
  };
  const table = useMantineReactTable({
    columns,
    data: datas || [],
    enableColumnResizing: true,
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,

    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["STT", "orderNumber"],
        right: ["action"],
      },
      columnVisibility: { id: true },
      density: "xs",
    },
    enableRowSelection: false,
    mantineTableContainerProps: {
      style: { maxHeight: height - 100, minHeight: height - 100 },
    },
    enableStickyHeader: true,
    enableColumnFilters: true,
    enableSorting: true,
    enableColumnActions: true,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    rowCount,
    onPaginationChange: setPagination,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "550",
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      pagination,
    },
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
  });

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      // 190 là chiều cao của phần phân trang
      // headerHeight là chiều cao của phần header
      setHeight(window.innerHeight - (130 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, []);

  const openModalEdit = () => {
    if (
      isSelectedItem &&
      (isSelectedItem.length < 1 || isSelectedItem.length > 1)
    )
      NotificationExtension.Warn("Xin vui lòng chọn 1 đơn hàng để chỉnh sửa !");
    else {
      const isAdmin =
        localStorage.getItem("userName") === "hieuhq@hacom.vn" ||
        localStorage.getItem("userName") === "manhnv@hacom.vn";

      const isAssignedToCurrentUser =
        isSelectedItem[0].assignToName === localStorage.getItem("userName");

      if (!isAdmin && !isAssignedToCurrentUser) {
        editItem(isSelectedItem[0].id);
      } else {
        NotificationExtension.Fails(
          "Bạn không có quyền để chỉnh sửa đơn hàng này",
        );
      }
    }
  };

  // Call API đồng bộ dữ liệu với POS
  const updateOrderData = async (orderId: number, orderNumber: string) => {
    try {
      const repository = new Repository(
        process.env.REACT_APP_Demo_APP_API_URL2,
      );
      const url = `${API_ROUTE.UPDATE_SYNC_TO_POST}`;
      const payload = {
        orderId,
        orderNumber,
      };

      const response = await repository.post(url, payload);

      if (response?.httpStatusCode === 200) {
        NotificationExtension.Success("Cập nhật dữ liệu thành công!");
        await fetchData();
      } else {
        NotificationExtension.Fails("Cập nhật dữ liệu thất bại!");
      }
    } catch (error) {
      console.error("Error updating order data:", error);
      NotificationExtension.Fails("Có lỗi xảy ra khi cập nhật dữ liệu!");
    }
  };

  const openModalPos = () => {
    if (isSelectedItem && isSelectedItem.length < 1)
      NotificationExtension.Warn("Xin vui lòng chọn dữ liệu !");
    else {
      const ids = isSelectedItem;
      if (
        localStorage.getItem("userName") === "hieuhq@hacom.vn" ||
        localStorage.getItem("userName") === "manhnv@hacom.vn"
      ) {
        if (ids.some((item) => !item.assignToId || !item.assignToName)) {
          NotificationExtension.Warn(
            "Đơn hàng đang chọn chưa chọn người phụ trách!",
          );
        } else if (
          ids.some((item) => item.orderStatus === "TRANSFER_POS_SUCCESS")
        ) {
          NotificationExtension.Warn("Đơn hàng này đã được đẩy sang POS!");
        } else if (ids.some((item) => item.orderStatus.includes("CANCEL"))) {
          NotificationExtension.Warn("Đơn hàng đang chọn đã huỷ!");
        } else if (ids.some((item) => item.orderStatus === "SUCCESS")) {
          NotificationExtension.Warn("Đơn hàng đang chọn đã xử lý thành công!");
        } else posItem(ids.map((item) => item?.id));
      } else {
        const checkAssign = isSelectedItem.every(
          (item) => item.assignToName === localStorage.getItem("userName"),
        );
        if (checkAssign) {
          if (ids.some((item) => !item.assignToId || !item.assignToName)) {
            NotificationExtension.Warn(
              "Đơn hàng đang chọn chưa chọn người phụ trách!",
            );
          } else if (
            ids.some((item) => item.orderStatus === "TRANSFER_POS_SUCCESS")
          ) {
            NotificationExtension.Warn("Đơn hàng này đã được đẩy sang POS!");
          } else if (ids.some((item) => item.orderStatus.includes("CANCEL"))) {
            NotificationExtension.Warn("Đơn hàng đang chọn đã huỷ!");
          } else if (ids.some((item) => item.orderStatus === "SUCCESS")) {
            NotificationExtension.Warn(
              "Đơn hàng đang chọn đã xử lý thành công!",
            );
          } else posItem(ids.map((item) => item?.id));
        } else
          NotificationExtension.Warn(
            "Đơn hàng đang chọn không thuộc quyền quản lý của bạn!",
          );
      }
    }
  };

  const openModalDelete = () => {
    if (isSelectedItem && isSelectedItem.length < 1)
      NotificationExtension.Warn("Xin vui lòng chọn dữ liệu !");
    else {
      const ids = isSelectedItem;
      deleteItem(ids.map((item) => item?.id));
    }
  };

  const openModalAssign = () => {
    if (isSelectedItem && isSelectedItem.length < 1)
      NotificationExtension.Warn("Xin vui lòng chọn dữ liệu !");
    else {
      const ids = isSelectedItem;
      assignItem(ids.map((item) => item?.id));
    }
  };

  function deleteItem(idItem: number[]) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Xóa đơn hàng</Title>
        </>
      ),
      children: (
        <DeleteView
          onSearch={() =>
            fetchDataSaleOrder(
              pagination.pageIndex,
              pagination.pageSize,
              paramSearch?.KeySearch,
              paramSearch?.inActive,
            )
          }
          idItem={idItem}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  function assignItem(idItem: number[]) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Chọn người phụ trách đơn hàng</Title>
        </>
      ),
      children: (
        <AssignView
          onSearch={() =>
            fetchDataSaleOrder(
              pagination.pageIndex,
              pagination.pageSize,
              paramSearch?.KeySearch,
              paramSearch?.inActive,
            )
          }
          idItem={idItem}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  function editItem(id: number) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Chỉnh sửa trạng thái đơn hàng</Title>
        </>
      ),

      children: (
        <EditView
          id={id}
          onSearch={() =>
            fetchDataSaleOrder(
              pagination.pageIndex,
              pagination.pageSize,
              paramSearch?.KeySearch,
              paramSearch?.inActive,
            )
          }
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  function posItem(idItem: number[]) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Gửi đơn hàng sang POS</Title>
        </>
      ),

      children: (
        <PosView
          onSearch={() =>
            fetchDataSaleOrder(
              pagination.pageIndex,
              pagination.pageSize,
              paramSearch?.KeySearch,
              paramSearch?.inActive,
            )
          }
          idItem={idItem}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  function viewItem(id: number) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Chi tiết đơn hàng</Title>
        </>
      ),

      children: (
        <OrderView
          id={id}
          onSearch={() =>
            fetchDataSaleOrder(
              pagination.pageIndex,
              pagination.pageSize,
              paramSearch?.KeySearch,
              paramSearch?.inActive,
            )
          }
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }
  function viewUserOrder(userId: any) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Danh sách đơn hàng</Title>
        </>
      ),

      children: <UserView userId={userId} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  //#region Fetch data

  const fetchDataSaleOrder = async (
    index: number,
    size?: number,
    KeySearch?: string,
    inActive?: boolean,
    empId?: string,
  ) => {
    setLoading(true);
    setDatas([]);
    setError(undefined);
    const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL2);
    try {
      let urlSearch = `${API_ROUTE.GET_LIST_SALE_ORDER}?Skip=${
        index * (size ?? 0)
      }&Take=${size}`;
      if (formSeachInput.getValues().KeySearch)
        urlSearch += `&KeySearch=${formSeachInput.getValues().KeySearch}`;

      if (!isNullOrUndefined(inActive))
        urlSearch = urlSearch + `&Active=` + inActive;

      if (!isNullOrUndefined(inputEmail) && inputEmail !== "") {
        urlSearch = urlSearch + `&BuyerEmail=${inputEmail}`;
      }
      if (!isNullOrUndefined(selectedStatus) && selectedStatus !== "") {
        urlSearch = urlSearch + `&Status=${selectedStatus}`;
      }
      if (!isNullOrUndefined(selectedAssign) && selectedAssign !== "") {
        const parts = selectedAssign.split("-");
        const afterPlus = parts.slice(1).join("+");
        urlSearch = urlSearch + `&IssuedUser=${afterPlus}`;
      }
      if (
        !isNullOrUndefined(startDate) &&
        startDate !== null &&
        endDate === null
      ) {
        const dateObject = new Date(startDate);
        const formattedDate = dateObject.toISOString();
        urlSearch = urlSearch + `&StartDate=${formattedDate}`;
      }
      if (formSeachInput.getValues().StartDate) {
        urlSearch += `&StartDate=${formatDateNotTimeZone(
          formSeachInput.getValues().StartDate,
        )}`;
      }
      if (formSeachInput.getValues().EndDate) {
        urlSearch += `&EndDate=${formatDateNotTimeZone(
          formSeachInput.getValues().EndDate,
        )}`;
      }
      if (formSeachInput.getValues().empId) {
        urlSearch += `&EmpId=${formSeachInput.getValues().empId}`;
      }
      let callapi = await repository.get(urlSearch);
      if (!callapi) {
        setRowCount(0);
        setDatas([]);
      } else {
        setDatas(callapi?.lists ?? []);
        setPagination({
          ...pagination,
        });
        setRowCount(callapi?.count ?? 0);
      }
      return callapi?.lists;
    } catch (error: any) {
      setError("Có lỗi xảy ra khi tải dữ liệu !");
      return null;
    } finally {
      setLoading(false);
      sessionStorage.setItem(
        String(location.pathname),
        JSON.stringify({
          KeySearch: formSeachInput.getValues().KeySearch,
          empId: formSeachInput.getValues().empId,
          StartDate: formSeachInput.getValues().StartDate,
          EndDate: formSeachInput.getValues().EndDate,
          selectedStatus: selectedStatus,
        }),
      );
    }
  };

  const fetchData = async () => {
    await fetchDataSaleOrder(
      pagination.pageIndex,
      pagination.pageSize,
      paramSearch?.KeySearch,
      paramSearch?.inActive,
      paramSearch?.empId,
    );
  };

  useEffect(() => {
    fetchData();
    // fetchDataProvice();
    // loadDataOrderStatus();
    // loadDataEmployee();
  }, [pagination.pageIndex, pagination.pageSize]);

  useEffect(() => {
    fetchDataEmloy();
  }, []);

  useEffect(() => {
    if (buyerId) viewUserOrder(buyerId);
  }, [buyerId]);

  useEffect(() => {
    if (dataEmployee) {
      setDataOptionEmployee(
        dataEmployee.map((option) => {
          return {
            value: option?.id.toString() + "-" + option?.email_organ,
            label:
              "Email: " +
              option?.email_organ +
              " - " +
              "Tên nhân viên: " +
              option?.name,
          };
        }),
      );
    }
  }, [dataEmployee]);

  return (
    <>
      <Flex
        justify="space-between"
        align="center"
        style={{
          border: "1px solid #dee2e6",
          padding: "5px 10px",
        }}
      >
        <BreadCrumb />
        <AppAction openExportExcel={handleExport} />
      </Flex>
      <Box
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          flexWrap: "wrap",
          // marginTop: "10px",
        }}
      >
        <Grid style={{ width: "100%" }} mt={10}>
          <Grid.Col span={sizeGrid}>
            <Input
              size="sm"
              placeholder="Từ khoá"
              type="text"
              leftSection={<IconSearch color="#15aabf" />}
              key={formSeachInput.key("KeySearch")}
              {...formSeachInput.getInputProps("KeySearch")}
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Select
              size="sm"
              placeholder="Nhập tên nhân viên"
              type="text"
              clearable
              searchable
              data={dataEmLoy}
              leftSection={<IconUserCode color="#15aabf" />}
              key={formSeachInput.key("empId")}
              {...formSeachInput.getInputProps("empId")}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              size="sm"
              placeholder="Chọn ngày bắt đầu"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              value={
                formSeachInput.getValues()?.StartDate &&
                formSeachInput.getValues()?.StartDate?.length > 0
                  ? new Date(formSeachInput.getValues()?.StartDate)
                  : null
              }
              leftSection={<IconTimeDuration15 color="#15aabf" />}
              onChange={(date) => {
                formSeachInput.setValues((prev) => ({
                  ...prev,
                  StartDate: date ? formatDateNotTimeZone(date) : "",
                }));
              }}
              clearable
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              style={{ border: "1px solidrgb(0, 0, 0)" }}
              size="sm"
              placeholder="Chọn ngày kết thúc"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              value={
                formSeachInput.getValues()?.EndDate &&
                formSeachInput.getValues()?.EndDate?.length > 0
                  ? new Date(formSeachInput.getValues()?.EndDate)
                  : null
              }
              leftSection={<IconTimeDuration15 size={20} color="#15aabf" />}
              // maxDate={new Date(formSeachInput.getValues().StartTime)}
              // maxDate={
              //     formSeachInput.getValues().StartTime
              //         ? addMonths(new Date(formSeachInput.getValues().StartTime), 1)
              //         : undefined
              // }
              onChange={(date) => {
                formSeachInput.setValues((prev) => ({
                  ...prev,
                  EndDate: date ? formatDateNotTimeZone(date) : "",
                }));
              }}
              clearable
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Select
              size="sm"
              placeholder="Chọn trạng thái đơn hàng"
              searchable
              clearable
              value={selectedStatus}
              leftSection={<IconStack color="#15aabf" />}
              data={[
                // { value: "TAO_MOI", label: "Tạo mới" },
                { value: "CHO_XAC_NHAN", label: "Chờ xác nhận" },
                { value: "DA_TIEP_NHAN", label: "Đã tiếp nhận" },
                { value: "DA_PHAN_CONG", label: "Đã phân công" },
                { value: "CHO_LAY_HANG", label: "Chờ lấy hàng" },
                { value: "DANG_GIAO", label: "Đang giao" },
                { value: "HOAN_THANH", label: "Hoàn thành" },
                { value: "DA_HUY", label: "Đã huỷ" },
              ]}
              onChange={(value) => {
                setSelectedStatus(value || "");
              }}
              // data={dataOrderStatus}
              // onClick={() => {
              //   if (dataOrderStatus.length === 0) {
              //     loadDataOrderStatus();
              //   }
              // }}
              // onChange={(value) => {
              //   setSelectedStatus(value || "");
              // }} // Cập nhật trạng thái đơn hàng
            />
          </Grid.Col>
          {/* <Grid.Col span={sizeGrid}>
            <Select
              size="sm"
              placeholder="Chọn người phụ trách"
              searchable
              clearable
              data={dataOptionEmployee}
              onClick={() => {
                if (dataOptionEmployee.length === 0) {
                  loadDataEmployee();
                }
              }}
              onChange={(value) => {
                setSelectedAssign(value || "");
              }} // Cập nhật người phụ trách
            />
          </Grid.Col> */}
          <Grid.Col span={sizeGrid}>
            <Button
              type="submit"
              leftSection={<IconSearch size={20} />}
              color="blue"
              variant="outline"
              onClick={async () => {
                await fetchData();
              }}
            >
              Tìm kiếm
            </Button>{" "}
          </Grid.Col>
        </Grid>
      </Box>

      <div className="mt-5" style={{ marginTop: "10px" }}>
        <MantineReactTable table={table} />
      </div>
    </>
  );
};

export default OrderList;
